//
// DISCLAIMER
//
// Copyright 2026 ArangoDB GmbH, Cologne, Germany
//

import { PackPlanStatus } from "../../api/data/v1/idata";

export const compareAvailabilityZone = (a?: string, b?: string) => {
  if (!a && !b) {
    return 0;
  }
  if (!a) {
    return 1;
  }
  if (!b) {
    return -1;
  }
  return a.localeCompare(b, undefined, { numeric: true });
};

// grpc-gateway JSON returns enum names as strings; generated TS enums are numeric.
export const normalizePackPlanStatus = (status?: PackPlanStatus | string | null): PackPlanStatus | undefined => {
  if (status == null || status === "") {
    return undefined;
  }
  if (typeof status === "number") {
    return status;
  }
  const fromName = PackPlanStatus[status as keyof typeof PackPlanStatus];
  if (typeof fromName === "number") {
    return fromName;
  }
  const n = Number(status);
  if (Number.isFinite(n)) {
    return n as PackPlanStatus;
  }
  return undefined;
};
